/*
 * gtm-events.js
 * ---------------------------------------------------------------
 * All GA4 event definitions. This is the ONLY file you edit when
 * adding a new event. Loads after gtm-core.js.
 * ---------------------------------------------------------------
 */
(function () {
  'use strict';
  if (!window.GTM) return;
  var G = window.GTM;

  // G.debug = true;   // uncomment while testing to log every push

  /* =========================================================
     ACTIVE: add_to_cart
     ========================================================= */
  G.onAjax(/\/cart\/add(\.js)?/, function (json) {
    var lines = json.items ? json.items : (json.variant_id ? [json] : []);
    if (!lines.length) return;
    G.push('add_to_cart', lines.map(function (li) { return G.item(li); }));
  });

  /* Keep the cached cart in sync after an add, without double-firing. */
  G.onAjax(/\/cart(\.js)?$/, function (json) {
    if (json && json.items) G.updateCart(json.items);
  });


  /* =========================================================
     READY TO ENABLE - uncomment the block you want
     ========================================================= */

  /* ---- remove_from_cart + quantity changes ----
  G.onAjax(/\/cart\/(change|update)(\.js)?/, function (json) {
    if (!json || !json.items) return;
    var d = G.diffCart(json.items);
    if (d.removed.length) {
      G.push('remove_from_cart', d.removed.map(function (li) { return G.item(li); }));
    }
    if (d.added.length) {
      G.push('add_to_cart', d.added.map(function (li) { return G.item(li); }));
    }
  });
  */

  /* ---- view_item (product pages) ----
  if (G.ctx.product) {
    G.push('view_item', [G.item(G.ctx.product)]);
  }
  */

  /* ---- view_cart (cart page) ----
  if (G.ctx.template === 'cart' && G.ctx.cart) {
    G.push('view_cart', G.ctx.cart.items.map(function (li) { return G.item(li); }));
  }
  */

  /* ---- select_item + list context capture (collection / search pages) ----
     Requires data-product-id on each product card wrapper.
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-id]');
    if (!card || !G.ctx.list) return;
    var siblings = card.parentElement.children;
    G.rememberList(card.dataset.productId, {
      item_list_name: G.ctx.list.name,
      item_list_id:   String(G.ctx.list.id),
      index: Array.prototype.indexOf.call(siblings, card) + 1
    });
  }, true);
  */

  /* ---- begin_checkout (checkout button click) ----
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[name="checkout"], [href="/checkout"]')) return;
    G.push('begin_checkout', G.ctx.cart.items.map(function (li) { return G.item(li); }));
  }, true);
  */

  /* =========================================================
     HOW TO ADD A NEW EVENT
     ---------------------------------------------------------
     1. Page-load event:      G.push('event_name', [G.item(src)]);
     2. AJAX-triggered:       G.onAjax(/\/cart\/xyz/, function (json) { ... });
     3. Click-triggered:      document.addEventListener('click', ...) -> G.push(...)
     4. Extra Liquid data:    add it to snippets/gtm-context.liquid,
                              read it as G.ctx.yourField
     Then create a Custom Event trigger in GTM matching the event name.
     ========================================================= */
})();
